import React from 'react';
import css from './ListingPage.module.css';

const DescriptionTab = ({ title, longDescription, description }) => {
  return (
    <div className={css.tastingNotes}>
      <h2>{title}</h2>
      {longDescription || description ? (
        <p>{longDescription || description}</p>
      ) : (
        <>
          <p>
            This exceptional single cask from a renowned Heritage Distillery in Bardstown offers a unique investment opportunity.
          </p>
          <p>
            Stored in a bonded warehouse since distillation, ownership transfer includes digital certification and continued storage options.
          </p>
        </>
      )}
    </div>
  );
};

export default DescriptionTab;